import { FC, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import SidebarMenuItem from 'src/components/ui/atoms/SidebarMenuItem'
import SidebarMenuProductIcon from 'src/components/ui/molecules/SidebarMenuProductIcon/SidebarMenuProductIcon'
import useWizard from 'src/hooks/useWizard'
import { cn } from 'src/lib/cn'
import useSidebarStore from 'src/stores/useSidebarStore'
import { SIDEBAR_MENU_HOVER_ENTER_DELAY } from 'src/utils/constants/SidebarMenu'
import WizardPopupMenu from '../../Wizard/WizardPopupMenu'

const SIDEBAR_WIDTH = 230

const SidebarFooterDataAvailability: FC = () => {
  const isSidebarOpen = useSidebarStore(s => s.isOpen || s.searchInputFocusedId !== null)

  const { getDashboard: getDashboardWizard } = useWizard()
  const { pathname } = useLocation()

  useEffect(() => {
    getDashboardWizard()
  }, [])

  return (
    <SidebarMenuItem
      label={isSidebarOpen ? 'Data Availability' : ''}
      icon={<SidebarMenuProductIcon code="data_availability" />}
      aria-label="Data Availability"
      active={pathname === '/availability'}
      className={cn('px-3', isSidebarOpen && 'px-4')}
      menu={{
        isOpen: false,
        openOnHover: true,
        isBottomToTop: true,
        minLeft: SIDEBAR_WIDTH,
        delay: SIDEBAR_MENU_HOVER_ENTER_DELAY,
        content: <WizardPopupMenu />,
        className: 'py-0',
      }}
    />
  )
}

export default SidebarFooterDataAvailability
